import { v4 as uuid } from "uuid";
import { useTranslation } from "react-i18next";
import { DEFAULT_NOTE_TYPES, type Note, NOTE_DIRECTIONS, type Person } from "@/services/api";
import { getCurrentDate } from "@/shared/utils";
import type {
  CreateNoteRequest,
  NoteDirection,
  NoteStatus,
  UpdateNoteRequest,
} from "@/services/api/entities/note/types";
import type { NoteType } from "@/features/NotesManager/types";
import type { NoteEditorFormValues } from "@/features/NoteEditor/model";

export const getAllCommitments = (notes: Note[]): Note[] => {
  return notes.filter((item) => item.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT);
};

export const getHeaderTitle = (noteType: NoteType) => {
  const { t } = useTranslation();

  switch (noteType) {
    case DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT:
      return t("common.noteType.commitment", {
        count: 2,
      });

    case DEFAULT_NOTE_TYPES.DEFAULT_IDEA:
      return t("common.noteType.idea", {
        count: 2,
      });

    case DEFAULT_NOTE_TYPES.DEFAULT_NOTE:
      return t("common.noteType.note", {
        count: 2,
      });
  }
};

export const createNewTempNote = (noteType?: NoteType, currentPerson?: Person) => ({
  attachments: [],
  direction: NOTE_DIRECTIONS.OUTGOING as NoteDirection,
  createdDate: "",
  dueDate: "",
  id: `new-${uuid()}`,
  important: false,
  noteDate: getCurrentDate(),
  noteType: { name: noteType ? noteType : DEFAULT_NOTE_TYPES.DEFAULT_NOTE },
  personId: currentPerson?.id ?? "",
  status: "TO_DO" as NoteStatus,
  text: "",
  title: "",
  person: currentPerson ?? null,
});

export const prepareCreateNotePayload = (
  data: NoteEditorFormValues["currentNote"],
): CreateNoteRequest => {
  if (data.dueDate?.length && data.noteType.name !== DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT) {
    data.dueDate = "";
  }
  return {
    attachments: data.attachments as CreateNoteRequest["attachments"],
    direction: data.direction ?? null,
    dueDate: data.dueDate ?? "",
    important: data.important ?? null,
    noteDate: data.noteDate ?? "",
    noteType: { name: data.noteType.name },
    personId: data.personId as string,
    status: data.status ?? null,
    text: data.text ?? null,
    title: data.title ?? null,
  };
};

export const prepareUpdateNotePayload = (
  data: NoteEditorFormValues["currentNote"],
): UpdateNoteRequest => {
  if (data.dueDate?.length && data.noteType.name !== DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT) {
    data.dueDate = "";
  }
  return {
    attachments: data.attachments as UpdateNoteRequest["attachments"],
    direction: data.direction ?? null,
    dueDate: data.dueDate ?? "",
    id: data.id ?? "",
    important: data.important ?? null,
    noteDate: data.noteDate ?? "",
    noteType: data.noteType,
    personId: data.personId as string,
    status: data.status ?? null,
    text: data.text ?? null,
    title: data.title ?? null,
  };
};
